import { Validators } from '@angular/forms';
import { ControlProperty, DatepickerRangeModel, DatepickerRangeOutput } from '../../../../common/models';
import { INTEGER_FRACTIONAL_NUMBER_PATTERN } from '../../../../common/constants';
import { DraggableFilterType } from '../../../constants';
import { AddressType } from './address-type';

export enum AddressManagementFilterName {
  Sources = 'sources',
  ExtID = 'extId',
  Name = 'name',
  Country = 'country',
  City = 'city',
  Street = 'street',
  HouseNumber = 'houseNumber',
  Postcode = 'postcode',
  Latitude = 'latitude',
  Longitude = 'longitude',
  PlantGateName = 'plantGateName',
  DeviationFromGate = 'deviationFromGate',
  CreationDate = 'creationDate',
}

export const ADDRESS_MANAGEMENT_FILTER_TYPE_BY_NAME: Map<AddressManagementFilterName, DraggableFilterType> = new Map([
  [AddressManagementFilterName.Sources, DraggableFilterType.MultipleSelect],
  [AddressManagementFilterName.ExtID, DraggableFilterType.Input],
  [AddressManagementFilterName.Name, DraggableFilterType.Input],
  [AddressManagementFilterName.Country, DraggableFilterType.Input],
  [AddressManagementFilterName.City, DraggableFilterType.Input],
  [AddressManagementFilterName.Street, DraggableFilterType.Input],
  [AddressManagementFilterName.HouseNumber, DraggableFilterType.Input],
  [AddressManagementFilterName.Postcode, DraggableFilterType.Input],
  [AddressManagementFilterName.Latitude, DraggableFilterType.Input],
  [AddressManagementFilterName.Longitude, DraggableFilterType.Input],
  [AddressManagementFilterName.PlantGateName, DraggableFilterType.Input],
  [AddressManagementFilterName.DeviationFromGate, DraggableFilterType.Input],
  [AddressManagementFilterName.CreationDate, DraggableFilterType.RangeDatepicker],
]);
export const ADDRESS_FILTER_SELECT_OPTIONS_BY_NAME = new Map<AddressManagementFilterName, string[]>([
  [AddressManagementFilterName.Sources, Object.values(AddressType)],
]);

export class AddressListFiltersModelBase {
  [AddressManagementFilterName.Sources]: AddressType[] = [];
  [AddressManagementFilterName.ExtID]: string = null;
  [AddressManagementFilterName.Name]: string = null;
  [AddressManagementFilterName.Country]: string = null;
  [AddressManagementFilterName.City]: string = null;
  [AddressManagementFilterName.Street]: string = null;
  [AddressManagementFilterName.HouseNumber]: string = null;
  [AddressManagementFilterName.Postcode]: string = null;
  [AddressManagementFilterName.Latitude]: number = null;
  [AddressManagementFilterName.Longitude]: number = null;
  [AddressManagementFilterName.PlantGateName]: number = null;
  [AddressManagementFilterName.DeviationFromGate]: number = null;
  [AddressManagementFilterName.CreationDate] = new DatepickerRangeModel();

  constructor(params?: AddressListFiltersModelBase) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AddressListFilterForm {
  constructor(
    model: AddressListFiltersModelBase,
    public deviationFromGate: ControlProperty<number> = [
      model.deviationFromGate,
      [Validators.pattern(INTEGER_FRACTIONAL_NUMBER_PATTERN)],
    ],
    public plantGateName: ControlProperty<number> = [model.plantGateName, []],
    public longitude: ControlProperty<number> = [
      model.longitude,
      [Validators.pattern(INTEGER_FRACTIONAL_NUMBER_PATTERN)],
    ],
    public latitude: ControlProperty<number> = [
      model.latitude,
      [Validators.pattern(INTEGER_FRACTIONAL_NUMBER_PATTERN)],
    ],
    public postcode: ControlProperty<string> = [model.postcode, []],
    public city: ControlProperty<string> = [model.city, []],
    public houseNumber: ControlProperty<string> = [model.houseNumber, []],
    public street: ControlProperty<string> = [model.street, []],
    public extId: ControlProperty<string> = [model.extId, []],
    public country: ControlProperty<string> = [model.country, []],
    public name: ControlProperty<string> = [model.name, []],
    public sources: ControlProperty<AddressType[]> = [model.sources, []],
    public creationDate: ControlProperty<DatepickerRangeOutput> = [new DatepickerRangeOutput(model.creationDate), []],
  ) {}
}

export enum AddressFormGroupName {
  Details = 'details',
  ExternalIds = 'extIds',
}
